import { cn } from 'cn';

import { Spinner } from '../Spinner';

type P = {
  readonly isLoading: boolean;
  readonly loadingText?: string;
  readonly spinnerDelay?: number;
} & ComponentStyling;

/**
 * Overlays the nearest `relative` ancestor with an animated blur+fade effect
 * and a centered spinner.
 *
 * The overlay only mounts when `isLoading` is true, so the animation fires
 * fresh on each loading transition without needing explicit exit animation.
 *
 * Position the overlay via `className` (e.g. `inset-0`, `-inset-1`).
 * The default renders flush with the parent edges.
 */
export function LoadingOverlay({
  className,
  isLoading,
  loadingText,
  spinnerDelay = 1600,
  style,
}: P) {
  if (!isLoading) {
    return null;
  }

  return (
    <div
      className={cn('animate-loadingOverlay absolute inset-0 z-20', className)}
      style={style}
    >
      <Spinner initialDelay={spinnerDelay} title={loadingText} />
    </div>
  );
}
